import { Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  ContactFragment,
  contactFragmentString,
} from '../../fragments/__generated__/ContactFragment'

import getSharedContactsRawString from '../GetSharedContacts.graphql'

const getSharedContactsString = [
  getSharedContactsRawString,
  contactFragmentString,
].join('\n\n')

export type GetSharedContactsData = {
  contactShares: {
    id: string
    contact: ContactFragment
    fromUser: {
      username: string
      firstName: string
      lastName: string
      email: string
    }
    createdAt: string
  }[]
}

export type GetSharedContactsVariables = {
  offset?: Maybe<number>
  limit?: Maybe<number>
}

export type GetSharedContacts = Operation<
  GetSharedContactsData,
  GetSharedContactsVariables
>

export const GetSharedContacts = ({
  offset,
  limit,
}: GetSharedContactsVariables = {}): GetSharedContacts => ({
  query: getSharedContactsString,
  variables: {
    offset,
    limit,
  },
})
